<template >
  <Modal ref="modal">
    <div class="modal-alert" id="modalConfirm" style="tabindex: 0;">
      <div class="modal-alert__wrap">
        <div class="modal-alert__head">
          <h1 class="modal-alert__title" style="font-size: 26px">{{title}}</h1>
        </div>
        <div class="modal-alert__body">
          <p class="modal-alert__msg"   style="font-size: 16px" v-html="content"></p>
        </div>
        <div class="modal-alert__btnArea">
          <button
            id="modal-confirm-btn-confirm"
            type="button"
            class="btn-alert-action"
            @click="confirm"
          >{{confirmButtonText}}</button>
          <button
            id="modal-confirm-btn-cancel"
            type="button"
            class="btn-alert-cancel"
            @click="cancel"
          >{{cancelButtonText}}</button>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script>
import Modal from "@/components/common/Modal.vue";
export default {
  components: {
    Modal,
  },
  data() {
    return {
      title: "확인",
      content: "확인해 주세요.",
      confirmButtonText: "확인",
      cancelButtonText: "취소",
      resolvePromise: undefined,
    };
  },
  methods: {
    show(content) {
      this.setContent(content);
      this.$refs.modal.open();

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
      });
    },
    confirm() {
      this.$refs.modal.close();
      this.resolvePromise(true);
    },
    cancel() {
      this.$refs.modal.close();
      this.resolvePromise(false);
    },
    setContent(content) {
      if (content == undefined) {
        return;
      }
      
      this.title = content.title ? content.title : this.title;
      this.content = content.content ? content.content : this.content;
      this.confirmButtonText = content.confirmButtonText
        ? content.confirmButtonText
        : this.confirmButtonText;
      this.cancelButtonText = content.cancelButtonText
        ? content.cancelButtonText
        : this.cancelButtonText;
    },
  },
};
</script>